import React from "react";
import VoucherTable from "../components/Vouchers/VoucherTable";

const VoucherDashboard = (props) => {
  const { user } = props;
  return <VoucherTable user={user} />;
};

export default VoucherDashboard;
